export const DIALOG_INITIALISED_ATTR = 'data-a11y-dialog-initialised'
